export default __webpack_public_path__ + "static/media/productivity.a33cd82d.svg";